<template src="./MapUp.html"></template>
<script lang="js">
import Vue from 'vue';
import LeafletMap from '@/components/leafletmap/LeafletMap.vue';
import Overview from '@/components/overview/Overview.vue';
import OtaChange from '@/components/otachange/OtaChange.vue';
import Livemap from '@/components/livemap/Livemap.vue';
import Feedback from '@/components/feedback/Feedback.vue';
import ManualUpdate from '@/components/manualupdate/ManualUpdate.vue';
import ManualUpdateViaBrowser from '@/components/manualupdate/ManualUpdateViaBrowser.vue';
import ErrorPage from '@/components/errorpage/ErrorPage.vue';
import axios from "axios";
import testdata from './testdata/mapupdate_information.json';
import ErrorType from '../../enums/error-types'
import {navigateTo, resolve} from "@seamless/router";

export default Vue.extend({
  name: 'nmouc-app-mrm-map-up',
  components: {
    LeafletMap,
    Overview,
    OtaChange,
    ManualUpdate,
    ManualUpdateViaBrowser,
    Livemap,
    Feedback,
    ErrorPage,
  },
  computed: {
    showMobileHint: function () {
      return this.$store.state.mapupdateInformation !== undefined &&
        !this.$store.getters.isDownloadManagerFeasible &&
        !this.$store.state.error &&
        this.$store.state.mode === 'overview';
    },
    showOtaChangeMobileHint: function () {
      return this.$store.state.mapupdateInformation !== undefined &&
        this.$store.state.mapupdateInformation.otaSupportEnabled &&
        !this.$store.getters.isOtaChangePossible;
    },
    prerequisitesAvailable() {
      let errorType = this.mapStateToErrorType()
      return errorType === "";
    },
  },
  watch: {
    'prerequisitesAvailable': function (available) {
      if (!available) {
        return
      }
      this.requestMapUpdateInformation()
    },
  },
  mounted() {
    setTimeout(() => this.validateIfVinIsAvailableAfterTimeout(), 90000);
  },
  methods: {
    validateIfVinIsAvailableAfterTimeout() {
      let errorType = this.mapStateToErrorType()
      if (errorType !== "") {
        this.$store.commit('setError', errorType)
      }
    },
    mapStateToErrorType() {
      if (!this.$store.state.jweAvailable) {
        return ErrorType.NO_JWE
      } else if (this.$store.state.baseURL === undefined) {
        return ErrorType.NO_BASEURL
      } else if (axios.defaults.params['context'] === undefined) {
        return ErrorType.NO_CONTEXT
      } else if (axios.defaults.params['context'] === "B2B" && axios.defaults.params['companyId'] === undefined) {
        return ErrorType.NO_COMPANYID
      } else if (this.$store.state.vin === undefined) {
        return ErrorType.NO_VIN
      }
      return ""
    },
    requestMapUpdateInformation() {
      if (process.env.VUE_APP_TESTDATA === "true") {
        if (process.env.VUE_APP_MAP_UPDATE_INFORMATION_ERROR === "true") {
          console.log("error", process.env.VUE_APP_MAP_UPDATE_INFORMATION_ERROR);
          this.$store.commit('setError', process.env.VUE_APP_MAP_UPDATE_INFORMATION_ERROR);
        } else {
          this.$store.commit('setMapupdateInformation', testdata);
          this.checkCurrentMode()
        }
      } else {
        axios.get(`/mapupdate/api/v1/vehicles/${this.$store.state.vin}/mapinformation`,
          {
            validateStatus: () => true,
          })
          .then((response) => {
            this.validateMapupdateInformationResponse(response)
          })
          .catch((error) => {
            console.log("error", error);
            this.$store.commit('setError', ErrorType.RETRY_LATER);
          })
      }
    },
    pollMapUpdateInformation(retry) {
      setTimeout(() =>
          axios.get(`/mapupdate/api/v1/vehicles/${this.$store.state.vin}/mapinformation/response/${retry.trackingId}`,
            {
              validateStatus: () => true,
              params: {
                retry: retry.nextRetry
              }
            }
          )
            .then((response) => {
              this.validateMapupdateInformationResponse(response)
            })
            .catch((error) => {
              console.log("error", error)
              this.$store.commit('setError', ErrorType.RETRY_LATER);
            })
        , retry.retryAfterMillis)
    },
    validateMapupdateInformationResponse(r) {
      switch (r.status) {
        case 200:
          this.$store.commit('setMapupdateInformation', r.data);
          this.checkCurrentMode()
          break;
        case 202:
          this.pollMapUpdateInformation(r.data)
          break;
        case 417:
          this.$store.commit('setError', ErrorType.CONTACT_SERVICE_PARTNER);
          break;
        case 504:
          if (this.validateIfResponseHasHuNotFoundError(r)) {
            this.$store.commit('setError', ErrorType.RETRY_LATER_NEW_VEHICLE);
          }
          this.$store.commit('setError', ErrorType.RETRY_LATER);
          break;
        case 570:
          this.$store.commit('setError', ErrorType.RETRY_LATER_NEW_VEHICLE);
          break;
        case 580:
          this.$store.commit('setError', ErrorType.MAINTENANCE);
          break;
        default:
          this.$store.commit('setError', ErrorType.CONTACT_SERVICE_PARTNER);
          break;
      }
    },
    validateIfResponseHasHuNotFoundError(response) {
      return response.data.error !== undefined &&
        response.data.error.errors !== undefined &&
        response.data.error.errors[0] !== undefined &&
        response.data.error.errors[0].description !== undefined &&
        response.data.error.errors[0].description === 'HU_NOT_FOUND';
    },
    checkCurrentMode() {
      if (!this.isCurrentModeAllowed()) {
        const newUrl = resolve({namespace: 'mapupdate', path: "/"});
        navigateTo(newUrl);
      }
    },
    isCurrentModeAllowed() {
      let mode = this.$store.state.mode
      if (mode === 'manualupdate') {
        return this.$store.state.mapupdateInformation && this.$store.state.mapupdateInformation.mapRegions.some(val => val.upToDate === false) && this.$store.getters.isDownloadManagerFeasible;
      } else if (mode === 'otachange') {
        return this.$store.getters.isOtaChangePossible;
      }
      return true
    }
  },
});
</script>
<style lang="scss" src="./MapUp.scss"></style>
